import { useEffect, useState } from 'react'
import { TilledFormState } from '../../../elements/Tilled/TilledFormTypes'

export const useTilledFormState = (initialState: TilledFormState, resetKey?: string) => {
  const [state, setter] = useState<TilledFormState>(initialState)
  // biome-ignore lint/correctness/useExhaustiveDependencies: resetKey intentionally invalidates state without changing its value
  useEffect(() => setter(initialState), [initialState, resetKey])
  return [state, setter] as const
}
